module.exports = __webpack_public_path__ + "static/media/agent-badge.964e3a18.png";